import { render, staticRenderFns } from "./TemplateCategoryPreview.vue?vue&type=template&id=2852e0b8&scoped=true"
import script from "./TemplateCategoryPreview.vue?vue&type=script&lang=js"
export * from "./TemplateCategoryPreview.vue?vue&type=script&lang=js"
import style0 from "./TemplateCategoryPreview.vue?vue&type=style&index=0&id=2852e0b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2852e0b8",
  null
  
)

export default component.exports